module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fbJVQ"))).then(() => parcelRequire('5erN3'));